import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import CheckBox from '../../common/CheckBox'
import { TatContext } from './context/context'

const DtcRow = ({ dtcId, destination_only, name, ecu }) => {
  const [state, dispatch] = useContext(TatContext)

  const showErrorOnDiffTypeDtcs = () => {
    if (
      state?.selected_dtc.find(
        (item) => item.destination_only !== destination_only
      )
    ) {
      alert(
        `You can't select both destination only and not destination only dtcs for DTCs edit mapping.`
      )
    } else {
      dispatch({
        type: 'select_dtc',
        data: {
          id: dtcId,
          destination_only: destination_only,
          name: name,
          ecu: ecu,
        },
      })
    }
  }

  return (
    <div className="inline-block text-black">
      <CheckBox
        name={`dtc_id[${dtcId}]`}
        value={dtcId}
        checked={
          state?.selected_dtc.find((item) => item.id === dtcId)?.id
            ? true
            : false
        }
        onChange={() => {
          showErrorOnDiffTypeDtcs()
        }}
      />
    </div>
  )
}

DtcRow.propTypes = {
  dtcId: PropTypes.number.isRequired,
  destination_only: PropTypes.bool.isRequired,
}

export default DtcRow
